module.exports = __webpack_public_path__ + "img/fifa_2.5427ba88.png";